import { render, staticRenderFns } from "./SalesClosuresDetails.vue?vue&type=template&id=467e9d77"
import script from "./SalesClosuresDetails.vue?vue&type=script&lang=js"
export * from "./SalesClosuresDetails.vue?vue&type=script&lang=js"
import style0 from "./SalesClosuresDetails.vue?vue&type=style&index=0&id=467e9d77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports